/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Checkinflyerrendering2Inputs */

const en_checkinflyerrendering2 = /** @type {(inputs: Checkinflyerrendering2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Creating …`)
};

const de_checkinflyerrendering2 = /** @type {(inputs: Checkinflyerrendering2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wird erstellt …`)
};

/**
* | output |
* | --- |
* | "Creating …" |
*
* @param {Checkinflyerrendering2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const checkinflyerrendering2 = /** @type {((inputs?: Checkinflyerrendering2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Checkinflyerrendering2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_checkinflyerrendering2(inputs)
	return de_checkinflyerrendering2(inputs)
});
export { checkinflyerrendering2 as "checkinFlyerRendering" }